import { flushSync } from 'react-dom';

export function transition(callback: () => void) {
    // @ts-expect-error -- new api
    if (document.startViewTransition) {
        // @ts-expect-error -- new api
        document.startViewTransition(() => flushSync(callback));
    } else {
        callback();
    }
}
